import { useEffect, useState } from 'react';
import { getLatestArticles } from '../../../helpers/BuilderHelper';
import { useLocale } from '../../../helpers/LangHelper';
import { Article } from '../../../types/Article';
import B2bArticleGrid from '../b2b-article-grid/b2b-article-grid';
import { B2BArticleGridSource } from './b2b-article-grid.constants';

export interface B2BArticleGridProps {
    source: B2BArticleGridSource;
    offset: number;
    initialArticles: Article[];
}

export const B2BArticleGrid = (props: B2BArticleGridProps) => {
    const { locale } = useLocale();
    const [articles, setArticles] = useState<Article[]>(props.initialArticles ?? []);
    const [offset, setOffsetArticle] = useState<number>(props.offset);
    const [isLoadingMoreArticles, setIsLoadingMoreArticles] = useState<boolean>(false);

    useEffect(() => {
        let cancelled = false;

        if (props.offset === offset) return;

        const fetchArticles = async () => {
            setIsLoadingMoreArticles(true);
            try {
                const newArticles = await getLatestArticles({ locale, offset, limit: 9 });
                if (!cancelled) {
                    setArticles((oldArticles) => [...oldArticles, ...newArticles]);
                }
            } catch (error) {
                console.error('Error fetching articles:', error);
            } finally {
                if (!cancelled) {
                    setIsLoadingMoreArticles(false);
                }
            }
        };

        fetchArticles();

        return () => {
            cancelled = true;
        };
    }, [locale, offset, props.offset]);

    return <B2bArticleGrid articles={articles} isLoadingMoreArticles={isLoadingMoreArticles} setOffsetArticle={setOffsetArticle} offsetArticle={offset} />;
};
